import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { Button } from './Button';

export const OpenMultilineResponse = (props) => {

    const { action } = props;
    const classes = useStyles();
    const [comment, setComment] = useState('');

    return (
        <Grid container justifyContent='center'>
            <Grid item xs={ 11 } sm={ 11 } md={ 11 } lg={ 10 }>
                <textarea className={ classes.area } rows={ 4 } onChange={ (e) => setComment(e?.target?.value) } placeholder="Ingresa tu respuesta" />
                <div className={ classes.groupBtns }>
                    {
                        comment ? (
                            <Button
                                title='Continuar'
                                action={ () => action(comment?.toLowerCase().trim()) }
                                directionX='flex-end'
                                breakPoints={[6, 5, 4, 4]}
                            />
                        ) : (
                            <Button
                                title='No, gracias'
                                action={ () => action('no') }
                                directionX='flex-end'
                                breakPoints={[5, 4, 3, 3]}
                                type='text'
                            />
                        )
                    }
                </div>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles({
    area: {
        borderRadius: 4,
        padding: 10,
		letterSpacing: '1px',
        resize: 'none',
        fontSize: 'clamp(.9rem, 5vw, 1rem)',
        width: '100%'
    },

    groupBtns: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: 15
    },

    span: {
        color: '#fff',
        marginLeft: 20,
        marginRight: 20,
        cursor: 'pointer'
    }
});